import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type Country } from '../../countriesListService'

export interface State {
  id: number
  name: string
  countryId?: number | null
}

export interface Phone extends BasePhone {
  organizationId: number | null
}

export interface PersonPhone extends BasePhone {
  personId?: number
}

export interface BasePhone {
  id: number | null
  addressId: number | null
  countryCode: string | null
  phoneNumber: string | null
  displayOrder?: number | null
  extension: string | null
}

export interface Address {
  id: any
  addressOne: string
  addressTwo?: string
  city: string
  state: State | null
  country: Country | null
  postalCode: string
  mailingAddress: boolean
}

export interface OrganizationAddress {
  id: number
  organizationId: number
  displayOrder?: number | null
  primaryAddress: Address
  secondaryAddress: Address
  phone: Phone | null
}

const createAddress = (address: OrganizationAddress): object => {
  return {
    ...(address.phone?.phoneNumber !== null && { phone: address.phone }),
    organizationId: address.organizationId,
    primaryAddress: address.primaryAddress,
    secondaryAddress: address.secondaryAddress?.addressOne !== '' ? address.secondaryAddress : null,
    ...(address.phone?.phoneNumber !== null && { phone: address.phone })
  }
}

export async function getOrgAddressesList (orgId: number): Promise<OrganizationAddress[]> {
  const urlPath = `/api/v1/organizations/${orgId}/addresses/`

  return await http.get(urlPath)
    .then(value => value.data)
    .catch(reason => { return [] })
}

export async function createOrgAddress (address: OrganizationAddress): Promise<boolean> {
  const addressObject = createAddress(address)

  const urlPath = `/api/v1/organizations/${address.organizationId}/addresses/`
  return await http.post(urlPath, addressObject, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}

export async function updateOrgAddress (address: OrganizationAddress, isCheckUpdateAllAddresses: boolean = false, isCheckUpdateAllChildrenAddresses: boolean = false): Promise<HttpResponse<boolean>> {
  const baseUrl = `/api/v1/organizations/${address.organizationId}/addresses/${address.id}/`
  const params = new URLSearchParams()
  params.append('positions', isCheckUpdateAllAddresses.toString())
  params.append('children', isCheckUpdateAllChildrenAddresses.toString())
  const urlPath = `${baseUrl}?${params.toString()}`

  const addressObject = createAddress(address)

  return await handleHttpRequest(http.put(urlPath, addressObject, { withCredentials: true }))
}

export async function deleteOrgAddress (orgId: number, addressId: number): Promise<boolean> {
  const urlPath = `/api/v1/organizations/${orgId}/addresses/${addressId}/`
  return await http.delete(urlPath, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}

export async function patchOrgAddress (orgId: number, addressId: number, request: any): Promise<boolean> {
  const urlPath = `/api/v1/organizations/${orgId}/addresses/${addressId}/`
  return await http.patch(urlPath, request, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}
